<template>
  <div data-cpt="core/ev-info">
    <ul class="select-list clearfix">
      <li class="select-item fl" v-for="(s, i) in selects" :key="i">
        <span v-if="showName">{{s.optionName}}:</span>
        {{s.optionValue}}
      </li>
    </ul>
  </div>
</template>

<style type="text/css" scoped>
/*  .selects-list .select-item {
    margin-left: 10px;
  }*/
</style>

<script type="text/javascript">
export default {
  props: {
    showName: Boolean,
    selects: Array
  }
  // computed: {
  //   selects () {
  //     return this.$store.state.evaluate.info.selectsInfo;
  //   }
  // }
};
</script>



// WEBPACK FOOTER //
// src/core/ev-info/selects.vue